import { render, staticRenderFns } from "./ResponseShift.vue?vue&type=template&id=9c97d8fc&scoped=true"
import script from "./ResponseShift.vue?vue&type=script&lang=js"
export * from "./ResponseShift.vue?vue&type=script&lang=js"
import style0 from "./ResponseShift.vue?vue&type=style&index=0&id=9c97d8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c97d8fc",
  null
  
)

export default component.exports